import { createGlobalStyle } from 'styled-components'
import { color } from '../color'
import Bold from './Sansation_Bold.ttf'
import Regular from './Sansation_Regular.ttf'
import Light from './Sansation_Light.ttf'

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    position: relative;
    min-height: 100vh;
    background-color: ${color.whiteBlue};
  }
  .container {
  }
  @font-face {
    font-family: 'SB';
    src: url('${Bold}') format('truetype');
  }
  @font-face {
    font-family: 'SR';
    src: url('${Regular}') format('truetype');
  }
  @font-face {
    font-family: 'SL';
    src: url('${Light}') format('truetype');
  }
`
export const font = {
  sansationBold: 'SB',
  sansationRegular: 'SR',
  SansationLight: 'SL',
}
export const fontSize = {
  veryLarge: '48px',
  larger: '36px',
  large: '24px',
  regularLarge: '21px',
  regular: '18px',
  medium: '14px',
  smallMedium: '12px',
  small: '9px',
}
